export const EventReplayConstants = {
  GET_EVENT_REPLAY_MACHINES_REQUEST: 'GET_EVENT_REPLAY_MACHINES_REQUEST',
  GET_EVENT_REPLAY_MACHINES_SUCCESS: 'GET_EVENT_REPLAY_MACHINES_SUCCESS',
  GET_EVENT_REPLAY_MACHINES_FAILURE: 'GET_EVENT_REPLAY_MACHINES_FAILURE',
  GET_EVENT_REPLAY_RUNS_REQUEST: 'GET_EVENT_REPLAY_RUNS_REQUEST',
  GET_EVENT_REPLAY_RUNS_SUCCESS: 'GET_EVENT_REPLAY_RUNS_SUCCESS',
  GET_EVENT_REPLAY_RUNS_FAILURE: 'GET_EVENT_REPLAY_RUNS_FAILURE',
  GET_EVENT_REPLAY_RUN_REQUEST: 'GET_EVENT_REPLAY_RUN_REQUEST',
  GET_EVENT_REPLAY_RUN_SUCCESS: 'GET_EVENT_REPLAY_RUN_SUCCESS',
  GET_EVENT_REPLAY_RUN_FAILURE: 'GET_EVENT_REPLAY_RUN_FAILURE',
  CREATE_EVENT_REPLAY_RUN_REQUEST: 'CREATE_EVENT_REPLAY_RUN_REQUEST',
  CREATE_EVENT_REPLAY_RUN_SUCCESS: 'CREATE_EVENT_REPLAY_RUN_SUCCESS',
  CREATE_EVENT_REPLAY_RUN_FAILURE: 'CREATE_EVENT_REPLAY_RUN_FAILURE',
  GENERATE_EVENT_REPLAY_RUN_REQUEST: 'GENERATE_EVENT_REPLAY_RUN_REQUEST',
  GENERATE_EVENT_REPLAY_RUN_SUCCESS: 'GENERATE_EVENT_REPLAY_RUN_SUCCESS',
  GENERATE_EVENT_REPLAY_RUN_FAILURE: 'GENERATE_EVENT_REPLAY_RUN_FAILURE',
  DELETE_EVENT_REPLAY_RUN_REQUEST: 'DELETE_EVENT_REPLAY_RUN_REQUEST',
  DELETE_EVENT_REPLAY_RUN_SUCCESS: 'DELETE_EVENT_REPLAY_RUN_SUCCESS',
  DELETE_EVENT_REPLAY_RUN_FAILURE: 'DELETE_EVENT_REPLAY_RUN_FAILURE',
  CLEAR_EVENT_REPLAY_RUN: 'CLEAR_EVENT_REPLAY_RUN'
};

// Mirrors EventReplayRunStatusEnum in the events service.
export const RUN_STATUS = {
  PREVIEWING: 'previewing',
  PREVIEW_READY: 'preview_ready',
  GENERATING: 'generating',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DELETED: 'deleted'
};

// Mirrors the kinds _skip_entry stamps in the events service: a tag with no data
// or no thresholds was not evaluated; a note is information on a tag that was.
export const SKIP_KIND = {
  NOTE: 'note',
  NO_DATA: 'no_data',
  THRESHOLDS: 'thresholds'
};

export const BUSY_STATUSES = [RUN_STATUS.PREVIEWING, RUN_STATUS.GENERATING];

export const REPLAY_LEVELS = ['warning', 'critical'];

export const REPLAY_FEATURES = ['rms_velocity', 'rms_acceleration', 'rms_demod_acceleration'];

// The chip tone for a run's status in the history table.
export const RUN_STATUS_TONE = {
  [RUN_STATUS.COMPLETED]: 'good',
  [RUN_STATUS.PREVIEW_READY]: 'good',
  [RUN_STATUS.FAILED]: 'bad'
};

export const POLL_INTERVAL_MS = 2500;

export const MAX_MACHINES_PER_RUN = 50;
